module.exports = __webpack_public_path__ + "img/cxwlogoimg.6e1b11a0.png";